/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  EXPORT_TO_EXCEL,
  EXPORT_TO_EXCEL_FAILURE,
  EXPORT_TO_EXCEL_SUCCESS
} from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse
} from "./reducerUtils";

const initialState = {
  data: null,
  state: "INIT",
  error: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case EXPORT_TO_EXCEL:
      return setLoadingState(state);
    case EXPORT_TO_EXCEL_SUCCESS:
      return setSuccessResponse(state, action);
    case EXPORT_TO_EXCEL_FAILURE:
      return setErrorResponse(state, action.errResp);
    default:
      return state;
  }
}
